var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset192(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.59 118.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:#2f55d4;}.cls-1{opacity:0.15;}.cls-2{fill:#ff8dd9;}.cls-3{fill:#fff;}.cls-4{fill:#3e6177;}.cls-5,.cls-8{fill:#2f55d4;}.cls-7{fill:#d5dfeb;}.cls-8{opacity:0.3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 192") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -14.21,
    y: 34.29,
    width: 147,
    height: 50,
    rx: 25,
    ry: 25,
    transform: "translate(-24.56 59.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.14,4.29a7.43,7.43,0,0,1,7.45,7.37l.09,11,.2,74.48-2.72-2.53a.85.85,0,0,0-1.13,0h0l-3.81,3.57L77.39,94.6a.85.85,0,0,0-1.13,0h0l-3.81,3.57-3.83-3.56a.85.85,0,0,0-1.13,0h0L63.66,98.2l-3.83-3.56a.85.85,0,0,0-1.13,0h0l-3.81,3.57L51,94.67a.85.85,0,0,0-1.13,0h0L46.1,98.24l-3.83-3.56a.84.84,0,0,0-1.13,0h0l-3.81,3.57-3.83-3.56a.84.84,0,0,0-1.13,0h0l-3.81,3.57-3.84-3.56a.84.84,0,0,0-1.13,0h0l-2.7,2.53-.23-85.38a7.43,7.43,0,0,1,7.42-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.14,4.29a7.43,7.43,0,0,1,7.45,7.37l.09,11,.2,74.48-2.72-2.53a.85.85,0,0,0-1.13,0h0l-3.81,3.57L77.39,94.6a.85.85,0,0,0-1.13,0h0l-3.81,3.57-3.83-3.56a.85.85,0,0,0-1.13,0h0L63.66,98.2l-3.83-3.56a.85.85,0,0,0-1.13,0h0l-3.81,3.57L51,94.67a.85.85,0,0,0-1.13,0h0L46.1,98.24l-3.83-3.56a.84.84,0,0,0-1.13,0h0l-3.81,3.57-3.83-3.56a.84.84,0,0,0-1.13,0h0l-3.81,3.57-3.84-3.56a.84.84,0,0,0-1.13,0h0l-2.7,2.53-.23-85.38a7.43,7.43,0,0,1,7.42-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.38,100.72l-.24-88.83a8.93,8.93,0,0,1,8.91-9l53.08-.14h0a9,9,0,0,1,8.93,8.86l.09,11,.21,77.94L85.6,96.11l-4.38,4.1-4.4-4.09-4.38,4.1L68,96.15l-4.38,4.1-4.4-4.08-4.38,4.1-4.4-4.08-4.38,4.1-4.4-4.08-4.38,4.1-4.4-4.08-4.38,4.1-4.4-4.08ZM24.15,93a2.32,2.32,0,0,1,1.58.62l2.81,2.6,2.79-2.62a2.33,2.33,0,0,1,3.18,0l2.8,2.6,2.79-2.61a2.33,2.33,0,0,1,3.19,0l2.8,2.6,2.79-2.62a2.34,2.34,0,0,1,3.17,0l2.81,2.61,2.79-2.61a2.34,2.34,0,0,1,3.18,0l2.81,2.6,2.79-2.61a2.35,2.35,0,0,1,3.18,0l2.81,2.61,2.79-2.62a2.34,2.34,0,0,1,3.17,0l2.81,2.61L84,93.5a2.34,2.34,0,0,1,3.18,0l.2.18-.19-71-.09-11a6,6,0,0,0-5.93-5.88h0l-53.08.14a5.93,5.93,0,0,0-5.92,6l.22,81.93.18-.17A2.33,2.33,0,0,1,24.15,93Zm-.46,2.82h0Zm.92,0h0Zm7.86,0h0Zm8.78,0h0Zm.92,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.62,35.8a5.68,5.68,0,1,1,5.68-5.68A5.69,5.69,0,0,1,10.62,35.8Zm0-8.36a2.68,2.68,0,1,0,2.68,2.68A2.68,2.68,0,0,0,10.62,27.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.44,88.49a5.68,5.68,0,1,1,5.68-5.68A5.69,5.69,0,0,1,98.44,88.49Zm0-8.36a2.68,2.68,0,1,0,2.68,2.68A2.68,2.68,0,0,0,98.44,80.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 14.59,
    cy: 42.03,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 94.05,
    cy: 21.96,
    r: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 58.47,
    y: 75.87,
    width: 23.07,
    height: 3,
    transform: "translate(-34.31 74.85) rotate(-46.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 66.37,
    y: 78.8,
    width: 14.8,
    height: 3,
    transform: "translate(-35.27 80.05) rotate(-47.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 31.11,
    y: 20.5,
    width: 42.38,
    height: 7.09,
    rx: 3.21,
    ry: 3.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 31.11,
    y: 33.54,
    width: 33.91,
    height: 7.09,
    rx: 3.21,
    ry: 3.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 31.11,
    y: 46.59,
    width: 25.43,
    height: 7.09,
    rx: 3.21,
    ry: 3.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 26.2,
    cy: 88.14,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 27.03,
    cy: 88.14,
    r: 19.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.2,109.24A21.09,21.09,0,1,1,47.29,88.14,21.12,21.12,0,0,1,26.2,109.24ZM26.2,70A18.09,18.09,0,1,0,44.29,88.14,18.12,18.12,0,0,0,26.2,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.12,86.12V83A2.79,2.79,0,0,1,19,80.68,3.6,3.6,0,0,1,21.36,80a3.65,3.65,0,0,1,2.37.72A2.77,2.77,0,0,1,24.62,83v3.16a2.77,2.77,0,0,1-.89,2.28,3.65,3.65,0,0,1-2.37.72A3.6,3.6,0,0,1,19,88.41,2.79,2.79,0,0,1,18.12,86.12Zm2.14,0a1,1,0,0,0,1.1,1.07q1.12,0,1.12-1.07V83q0-1.07-1.12-1.07A1,1,0,0,0,20.25,83Zm1.17,9.95a1,1,0,0,1,.11-.42l7.67-16a.93.93,0,0,1,.92-.56,1.4,1.4,0,0,1,.9.33,1,1,0,0,1,.41.85,1,1,0,0,1-.09.42l-7.69,16a1,1,0,0,1-1,.56,1.19,1.19,0,0,1-.89-.37A1.14,1.14,0,0,1,21.42,96.07Zm6.75-2.78V90.13a2.79,2.79,0,0,1,.87-2.28,3.6,3.6,0,0,1,2.36-.72,3.65,3.65,0,0,1,2.37.72,2.77,2.77,0,0,1,.89,2.28v3.16a2.77,2.77,0,0,1-.89,2.28,3.65,3.65,0,0,1-2.37.72,3.6,3.6,0,0,1-2.36-.72A2.79,2.79,0,0,1,28.18,93.29Zm2.14,0a1,1,0,0,0,1.1,1.07q1.12,0,1.12-1.07V90.13q0-1.07-1.12-1.07a1,1,0,0,0-1.1,1.07Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset192);
export default __webpack_public_path__ + "static/media/Asset192.2003a022bb87b18cc8c6af0a1e4146eb.svg";
export { ForwardRef as ReactComponent };